export default __webpack_public_path__ + "static/media/n_gauge_logo.33993495.png";